import React from 'react';
import '../../styles/SolucionesPublicitarias.css';

const New2025 = () => {
    return (
        <section className="new-2025-section py-5">
            <div className="container">
                {/* Título */}
                <div className="title-container" data-aos="fade-up">
                    <h2 className="title"><span>Lo Nuevo </span>del 2025</h2>
                    <div className="title-underline"></div>
                </div>

                <div className='row m-1'>
                    <div className='col-lg-6 col-md-12 mt-5'>
                        <div className='row align-items-center justify-content-center'>
                            <div className='col-md-6 text-center position-ralative z-4 d-none d-sm-block' data-aos="flip-right">
                                <img src="assets/lo-nuevo-lily.png" alt="" className='img-fluid img-filter' />
                            </div>
                            <div className='col-md-6 new-2025-p shadow-lg' data-aos="fade-up">
                                <div className='text-center' data-aos="zoom-in" data-aos-delay="400">
                                    <img src="assets/lo-nuevo-sentirse-mejor.png" alt="" className='img-fluid img-filter new-2025-img' />
                                </div>
                                <div className='text-center mt-3 mb-3 d-block d-sm-none'>
                                    <img src="assets/lo-nuevo-lily.png" alt="" className='img-fluid img-filter' />
                                </div>
                                <div>
                                    <p>
                                        Acompáñame todos los <span className='fw-bold'> miércoles a las 7:00 p. m. en “Vivir Mejor es Posible”</span> y
                                        juntos encontraremos las mejores herramientas para cuidar de tu salud.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-6 col-md-12 mt-5'>
                        <div className='row align-items-center justify-content-center'>
                            <div className='col-md-6 text-center position-ralative z-4 d-none d-sm-block' data-aos="flip-right">
                                <img src="assets/lo-nuevo-mariliana.png" alt="" className='img-fluid img-filter' />
                            </div>
                            <div className='col-md-6 new-2025-p shadow-lg' data-aos="fade-up">
                                <div className='text-center' data-aos="zoom-in" data-aos-delay="400">
                                    <img src="assets/lo-nuevo-health-talks.png" alt="" className='img-fluid img-filter new-2025-img' />
                                </div>
                                <div className='text-center mt-3 mb-3 d-block d-sm-none'>
                                    <img src="assets/lo-nuevo-mariliana.png" alt="" className='img-fluid img-filter' />
                                </div>
                                <div>
                                    <p>
                                        Todos los <span className='fw-bold'> jueves a las 7:00 p. m. en Health Talks</span> , 
                                        hablamos de salud de manera directa y cercana con los mejores expertos.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                </div>
            </div>
        </section>
    );
};

export default New2025;